import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import i18next from "i18next";
import { validatePasswordConditions } from "../../Helpers/validators";

const initialState = {
    isLong: false,
    containsNumber: false,
    variesInCase: false,
    hasSpecialChars: false,
};

const conditionMet = (condition) => {
    return condition ? "condition-met" : "condition-expected";
};

const PasswordStrength = ({ password }) => {
    const [conditions, setConditions] = useState(initialState);

    useEffect(() => {
        setConditions(validatePasswordConditions(password));
        return () => {
            setConditions(initialState);
        };
    }, [password]);

    if (password === undefined || password.length <= 0) {
        return null;
    }

    const renderConditions = () => {
        let conditionsArray = [];
        for (const [key, value] of Object.entries(conditions)) {
            conditionsArray.push(
                <Condition key={key} condition={{ key, value }} />
            );
        }

        return conditionsArray;
    };

    return (
        <div id="password-strength">
            <span>{i18next.t("form.password.strongPassword.title")}</span>
            <ul>{renderConditions()}</ul>
        </div>
    );
};

const Condition = ({ condition }) => {
    const { key, value } = condition;
    return (
        <li className={conditionMet(value)}>
            <ConditionCheckmark condition={value} />
            <span>{i18next.t(`form.password.strongPassword.${key}`)}</span>
        </li>
    );
};

const ConditionCheckmark = ({ condition }) => {
    if (condition) {
        return <i className="fa fa-check" aria-hidden="true"></i>;
    }

    return <i className="fa fa-circle fa-xs" aria-hidden="true"></i>;
};

PasswordStrength.propTypes = {
    password: PropTypes.string.isRequired,
};

Condition.propTypes = { condition: PropTypes.object };
ConditionCheckmark.propTypes = { condition: PropTypes.bool };

export default PasswordStrength;
